export default "/images/vendor/@coreui/icons/svg/flag/cif-gd.svg?cac3e3a660ac8f336787342d2df35c8d";